import { render, staticRenderFns } from "./KnowledgeFromAdmin.vue?vue&type=template&id=02f383e4&"
import script from "./KnowledgeFromAdmin.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFromAdmin.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/knowledge.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports